import { getMailOptionsCategories } from '@/API/repositories/mailCategory';
import { getPromotionCategories } from '@/API/repositories/promotion';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useEffect, useState } from 'react';

const useSendPromoMail = ({
	handleSendPromotionMailTemplate,
	showSendPromoMail,
}) => {
	const [promotions, setPromotions] = useState([]);
	const [selectedPromotion, setSelectedPromotion] = useState();
	const [accepted, setAccepted] = useState();

	const { hasUnfilledRequest, makeRequest } = useRequestsContext();

	const isLoading = hasUnfilledRequest(getMailOptionsCategories);

	const loadPromotions = async () => {
		const payload = {
			product: showSendPromoMail.product,
		};
		const res = await makeRequest(getPromotionCategories.bind(null, payload));

		if (res.data) {
			const options = res.data.map((d) => ({ label: d.name, value: d._id }));

			setPromotions(() => options);
			setSelectedPromotion(() => options[0]);
		}
	};

	const handleSend = () => {
		handleSendPromotionMailTemplate(
			selectedPromotion.label
		);
	};

	useEffect(() => {
		loadPromotions();
	}, []);

	return {
		isLoading,
		setAccepted,
		promotions,
		selectedPromotion,
		setSelectedPromotion,
		accepted,
		handleSend,
	};
};

export default useSendPromoMail;
